<template>
  <div>
    <div class="game_content" ref="gameClass">
      <div class="frame">
      </div>
      <div class="category" v-if="swipoGameThemes === 'SEASONAL'">{{ gameName }}</div>
      <div class="category" v-else-if="swipoGameThemes !== 'NO_CATEGORY'">{{ translateCategory(gameInfo.theme.toLowerCase()) }}</div>
      <img src="static/images/quotes.png" class="quotes_img">
      <div class="game_desc_txt">{{ gameInfo.question }}</div>
      <img src="static/images/shadow_1.png" class="shadow_img">
      <div class="flex_row icons">
        <p class="correct_ans no_icon" ref="yesButton" @click="sendAnswer('yesButton', 1)">{{ getTranslations.game_answer_1 }}</p>
        <p class="wrong_ans yes_icon" ref="noButton" @click="sendAnswer('noButton',0)">{{ getTranslations.game_answer_0 }}</p>
      </div>
<!--      <div class="flex_row icons">-->
<!--        <p class="wrong_ans" ref="noButton" @click="sendAnswer('noButton',0)">{{ getTranslations.game_answer_0 }}</p>-->
<!--        <img src="static/images/swipe_artwork.png">-->
<!--        <p class="correct_ans" ref="yesButton" @click="sendAnswer('yesButton', 1)">{{ getTranslations.game_answer_1 }}</p>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off", no-nested-ternary: "off" */
import { mapState, mapGetters } from 'vuex';
import { Howl } from 'howler';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { equalHeightAndWidth, gameplayFooter } from '@/common/jQuery';
import Vue from 'vue';


export default {
  name: 'swipoGame',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      gameInfo: null, // NEW
      index: 0,
      translationKeyForAnswer: '',
      flyX: '',
      buttonPushed: false,
      rightAnswerSound: new Howl({
        src: ['/static/sounds/right_answer.ogg', '/static/sounds/right_answer.mp3'],
      }),
      wrongAnswerSound: new Howl({
        src: ['/static/sounds/wrong_answer.ogg', '/static/sounds/wrong_answer.mp3'],
      }),
    };
  },
  created() {
    this.initGameData();
  },
  mounted() {
    equalHeightAndWidth();
    this.$nextTick(() => { this.swipeCards(); this.loadImage(); });
    // eslint-disable-next-line no-plusplus
  },
  methods: {
    translateCategory(category) {
      return this.getTranslations[`game_category_${category}`];
    },
    loadImage() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
    },
    getPartOfAnswers(part) {
      if (part === 1) {
        return this.gameInfo.questions.slice(0, this.gameInfo.questions.length);
      }
      return null;
    },
    calculateRefIndex(indexToBack) {
      return (indexToBack === 0) ? this.$refs[1][0] : (indexToBack === 1) ? this.$refs[2][0] : (indexToBack === 2) ? this.$refs[1][1] : this.$refs[2][1];
    },
    swipeCards() {
      let imgCount = 0;
      const data = this.miniGamesImagesForSwipe;
      const frame = document.body.querySelector('.frame');
      // eslint-disable-next-line no-use-before-define
      data.forEach(_data => appendCard(_data));
      let current = frame.querySelector('.card:last-child');
      let likeText = current.children[0];
      let startX = 0;
      let startY = 0;
      let moveX = 0;
      let moveY = 0;
      // eslint-disable-next-line no-use-before-define
      initCard(current);
      // eslint-disable-next-line no-shadow
      // document.querySelector('.wrong_ans').onclick = () => {
      // eslint-disable-next-line
      $('.wrong_ans').click(function () {
        moveX = 1;
        moveY = 0;
        // eslint-disable-next-line no-use-before-define
        completeForClick();
        // eslint-disable-next-line no-undef
        // eslint-disable-next-line no-undef
        $(this).addClass('');
      });
      // document.querySelector('.correct_ans').onclick = () => {
      // eslint-disable-next-line
      $('.correct_ans').click(function () {
        moveX = -1;
        moveY = 0;
        // eslint-disable-next-line no-use-before-define
        completeForClick();
        // eslint-disable-next-line no-undef
        // eslint-disable-next-line no-undef
        $(this).addClass('');
      });
      // eslint-disable-next-line no-shadow
      function appendCard(data) {
        const firstCard = frame.children[0];
        const newCard = document.createElement('div');
        newCard.className = 'card';
        newCard.style.backgroundImage = `url(${data})`;
        newCard.innerHTML = '<div class="bottom"></div>';
        if (firstCard) frame.insertBefore(newCard, firstCard);
        else frame.appendChild(newCard);
        // eslint-disable-next-line no-plusplus
        imgCount++;
      }

      function initCard(card) {
        // eslint-disable-next-line no-use-before-define
        card.addEventListener('pointerdown', onPointerDown);
      }

      function setTransform(x, y, deg, duration) {
        current.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${deg}deg)`;
        // eslint-disable-next-line no-restricted-globals,no-mixed-operators
        likeText.style.opacity = Math.abs((x / innerWidth * 2.1));
        // likeText.className = `is-like ${x > 0 ? 'like' : 'nope'}`
        // likeText.className = `is-like ${x > 0 ? audio2.play() : audio3.play()}`
        if (duration) current.style.transition = `transform ${duration}ms`;
      }


      function onPointerDown({ clientX, clientY }) {
        startX = clientX;
        startY = clientY;
        // eslint-disable-next-line no-use-before-define
        current.addEventListener('pointermove', onPointerMove);
        // eslint-disable-next-line no-use-before-define
        current.addEventListener('pointerup', onPointerUp);
        // eslint-disable-next-line no-use-before-define
        current.addEventListener('pointerleave', onPointerUp);
      }


      function onPointerMove({ clientX, clientY }) {
        moveX = clientX - startX;
        moveY = clientY - startY;
        // eslint-disable-next-line no-restricted-globals,no-mixed-operators
        setTransform(moveX, moveY, moveX / innerWidth * 50);
      }


      function onPointerUp() {
        current.removeEventListener('pointermove', onPointerMove);
        current.removeEventListener('pointerup', onPointerUp);
        current.removeEventListener('pointerleave', onPointerUp);
        if (Math.abs(moveX) > frame.clientWidth / 2) {
          current.removeEventListener('pointerdown', onPointerDown);
          // eslint-disable-next-line no-use-before-define
          complete();
          // eslint-disable-next-line no-use-before-define
        } else cancel();
      }
      function completeForClick() {
        // eslint-disable-next-line no-restricted-globals
        const flyX = (Math.abs(moveX) / moveX) * innerWidth * 1.3;
        const flyY = (moveY / moveX) * flyX;
        // eslint-disable-next-line no-mixed-operators,no-restricted-globals
        setTransform(flyX, flyY, flyX / innerWidth * 50, innerWidth);

        if (flyX < 0) {
          // eslint-disable-next-line no-undef
          $('.wrong_ans').removeClass('');
          // eslint-disable-next-line no-undef
          $('.correct_ans').addClass('');
          // eslint-disable-next-line no-undef
        } else if (flyX > 0) {
          // eslint-disable-next-line no-undef
          $('.correct_ans').removeClass('');
          // eslint-disable-next-line no-undef
          $('.wrong_ans').addClass('');
          // eslint-disable-next-line no-undef
        }

        const prev = current;
        const next = current.previousElementSibling;
        if (next) initCard(next);
        current = next;
        likeText = current.children[0];
        appendCard(data[imgCount % 4]);
        // eslint-disable-next-line no-restricted-globals
        setTimeout(() => frame.removeChild(prev), innerWidth);
        // eslint-disable-next-line no-undef
      }
      function complete() {
        // eslint-disable-next-line no-restricted-globals
        const flyX = (Math.abs(moveX) / moveX) * innerWidth * 1.3;
        const flyY = (moveY / moveX) * flyX;
        // eslint-disable-next-line no-mixed-operators,no-restricted-globals
        setTransform(flyX, flyY, flyX / innerWidth * 50, innerWidth);

        if (flyX < 0) {
          // eslint-disable-next-line no-undef
          $('.wrong_ans').removeClass('');
          // eslint-disable-next-line no-undef
          $('.correct_ans').addClass('');
          // eslint-disable-next-line no-undef
          $('.correct_ans').trigger('click');
        } else if (flyX > 0) {
          // eslint-disable-next-line no-undef
          $('.correct_ans').removeClass('');
          // eslint-disable-next-line no-undef
          $('.wrong_ans').addClass('');
          // eslint-disable-next-line no-undef
          $('.wrong_ans').trigger('click');
        }
        // const prev = current;
        const next = current.previousElementSibling;
        if (next) initCard(next);
        current = next;
        likeText = current.children[0];
        appendCard(data[imgCount % 4]);
        // eslint-disable-next-line no-restricted-globals
        // setTimeout(() => frame.removeChild(current), innerWidth);
      }

      function cancel() {
        setTransform(0, 0, 0, 100);
        // eslint-disable-next-line no-return-assign
        setTimeout(() => current.style.transition = '', 100);
      }
    },
    sendAnswer(ref, answer) {
      sessionStorage.setItem('flyX', '');
      Vue.delete(this.miniGamesImagesForSwipe, this.index);
      // eslint-disable-next-line no-plusplus
      this.index++;
      let answerIt = answer;
      if ((this.getTranslations[`game_answer_${answer}`].toLowerCase() === 'yes' || this.getTranslations[`game_answer_${answer}`].toLowerCase() === 'no')) {
        console.log('EN lang selected');
        this.translationKeyForAnswer = this.getTranslations[`game_answer_${answer}`].toLowerCase();
      } else if (answer === 0) {
        this.translationKeyForAnswer = 'yes';
      } else if (answer === 1) {
        this.translationKeyForAnswer = 'no';
      }
      if ((this.translationKeyForAnswer !== this.gameInfo.questions[answer].toLowerCase()) && answer === 0) {
        answerIt = 1;
      } else if ((this.translationKeyForAnswer !== this.gameInfo.questions[answer].toLowerCase()) && answer === 1) {
        answerIt = 0;
      }
      if (this.$refs[ref].classList.contains('game_correct')) {
        this.$refs[ref].classList.remove('game_correct');
      } else {
        this.$refs[ref].classList.remove('game_wrong');
      }
      let isCorrectAnswer = false;
      if (this.buttonPushed) {
        console.log('--> User 2 times. Wait for Answer....');
      } else {
        this.buttonPushed = true;
        this.$refs.gameClass.classList.add('no_events');
        this.$axios({
          url: `api/sendAnswerSwipo?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${answerIt}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          const responseData = response.data.data;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (responseData.status === 'WRONG_ANSWER') {
              this.$refs[ref].classList.add('game_wrong');
              this.wrongAnswerSound.play();
            } else if (responseData.status === 'CORRECT_ANSWER') {
              isCorrectAnswer = true;
              this.$refs[ref].classList.add('game_correct');
              this.rightAnswerSound.play();
            }
          }
          setTimeout(() => {
            this.normalTransition = true;
            this.storeSwipoGameData(isCorrectAnswer);
            this.$refs.gameClass.classList.remove('no_events');
          }, 1500);
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },
  },
  computed: {
    ...mapState('common', [
      'swipoGameThemes',
    ]),
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'gameName',
      'miniGames',
      'miniGamesImagesForSwipe',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/SwipoGame.vue